(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ion-coin"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('ion-coin')) return;
    class IonCoin extends HTMLElement {
      connectedCallback() {
        try { this.models = JSON.parse(this.dataset.models); } catch (e) { this.models = []; }
        if (!this.models.length) return;
        this.front = this.querySelector('.ioncoin__front');
        this.back = this.querySelector('.ioncoin__back');
        this.spin = this.querySelector('.ioncoin__spin');
        var start = parseInt(this.dataset.start, 10) || 0;
        this.period = parseInt(this.dataset.period, 10) || 16000;
        this.half = this.period / 2;
        this.set = (el, i) => { el.style.backgroundImage = "url('" + this.models[i % this.models.length] + "')"; };
        this.set(this.front, start);
        this.set(this.back, start + 1);
        this.next = start + 2;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.lastBoundary = 0;
        var tick = () => {
          if (!this.anim && this.spin.getAnimations) { this.anim = this.spin.getAnimations()[0]; }
          if (this.anim && this.anim.currentTime != null) {
            var k = Math.floor(this.anim.currentTime / this.half);
            while (k > this.lastBoundary) {
              this.lastBoundary += 1;
              if (this.lastBoundary % 2 === 1) { this.set(this.front, this.next); }
              else { this.set(this.back, this.next); }
              this.next += 1;
            }
          }
          this.raf = requestAnimationFrame(tick);
        };
        this.raf = requestAnimationFrame(tick);
      }
      disconnectedCallback() { if (this.raf) cancelAnimationFrame(this.raf); }
    }
    customElements.define('ion-coin', IonCoin);
  })();
  } catch(e) { console.error(e); }
})();

})();
